import React from 'react'
import { CardWithImage } from '../../elements/CardWithImage'
import { HeadingBlock } from '../HeadingBlock'
import { containerMaxWidth, mq } from '../../utils'
import { IProps } from './index'

const CONTENT_GRID_GAP = '1.75rem'

export const CardsWithImage: React.FC<IProps> = ({ title, cards }) => {
  return (
    <div className="cards-with-image">
      {title ? (
        <div className="cards-with-image__title">
          <HeadingBlock text={title} />
        </div>
      ) : null}
      <ul className="cards-with-image__content">
        {cards.map((card) => (
          <li key={card.title} className="cards-with-image__item">
            <CardWithImage {...card} />
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .cards-with-image {
            width: calc(100% / 14 * 12);
            margin: 0 auto;

            @media (${mq.mobile}) {
              &__content {
                display: flex;
                flex-direction: column;
                grid-gap: 64px;
              }
            }

            &__title {
              margin-bottom: 1rem;
            }

            &__header + &__content {
              margin-top: 3.75rem;
            }
          }

          @media (${mq.tablet}) {
            .cards-with-image {
              &__content {
                max-width: ${containerMaxWidth};
                padding: 0;
                margin: 0 auto;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-gap: ${CONTENT_GRID_GAP};
              }

              &__title {
                grid-column: 2/3;
                margin-bottom: 2rem;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
